/** 캘린더 테마 관리 API — /api/admin/calendar-themes (admin_calendar_themes CRUD). */
import { apiClient } from './client';

export interface CalThemeRow {
  id: number;
  theme_key: string;
  name: string;
  description: string | null;
  tokens: Record<string, string>;
  is_builtin: boolean;
  enabled: boolean;
  scope: string;
  institution_id: string | null;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface CalThemeInput {
  theme_key?: string;
  name?: string;
  description?: string | null;
  tokens?: Record<string, string>;
  enabled?: boolean;
  sort_order?: number;
}

export async function listCalendarThemes(): Promise<CalThemeRow[]> {
  const { data } = await apiClient.get<{ themes: CalThemeRow[] }>('/admin/calendar-themes');
  return data.themes ?? [];
}
export async function createCalendarTheme(input: CalThemeInput): Promise<CalThemeRow> {
  const { data } = await apiClient.post<{ theme: CalThemeRow }>('/admin/calendar-themes', input);
  return data.theme;
}
export async function updateCalendarTheme(id: number, patch: CalThemeInput): Promise<CalThemeRow> {
  const { data } = await apiClient.patch<{ theme: CalThemeRow }>(`/admin/calendar-themes/${id}`, patch);
  return data.theme;
}
export async function deleteCalendarTheme(id: number): Promise<void> {
  await apiClient.delete(`/admin/calendar-themes/${id}`);
}
